import { useMPEFetch } from '@retail/app/hooks';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { mpeApi } from '@retail/mgpris/config';
import { HierarchyFilterContextDTO } from '@retail/my-assortment/types';
import { QueryOptions } from '@shared/fetch-utils';
import { buildUrl } from '@shared/utils';

interface Props extends QueryOptions {
  assortmentId: number;
  supplierNumber: number;
}

export function useFetchPriceControlFilterContext({
  assortmentId,
  supplierNumber,
  ...queryOptions
}: Props) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<HierarchyFilterContextDTO>({
    method: 'GET',
    queryKey: ['price-control-items-event', assortmentId, supplierNumber],
    token,
    url: buildUrl({
      base: mpe.url,
      route:
        mpeApi.priceControl.assortment.assortmentId.supplier.supplierNumber.filterContext.getFullLinkPath(
          {
            assortmentId,
            supplierNumber,
          }
        ),
    }),
    ...queryOptions,
  });
}
